<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <yz-daterange @dateRange="getChooseTime"></yz-daterange>
        <el-input v-model.trim="inputVal" class="input_s200" placeholder="请输入备注" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="commonInfo">
        <div class="content">
          <h3>时间：{{ value?value[0]:'' }}~{{ value?value[1]:'' }}</h3>
          <h3>收入总额：{{ total ? total : '0.00' }}元</h3>
          <h3>总单数：{{ totalOrderNum ? totalOrderNum : '0' }}</h3>
        </div>
      </div>
      <div class="commonTable">
        <el-table :data="tableData" tooltip-effect="light">
          <el-table-column prop="createTimeStr" label="时间">
          </el-table-column>
          <el-table-column label="收取金额">
            <template slot-scope="scope">
              <span>{{ (scope.row.price * 1).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.remark || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="loginType == 1" :show-overflow-tooltip="true" label="操作" width="80">
            <template slot-scope="scope">
              <yz-btn type="delete" @click="delOrder(scope.row.id)">删除</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="pageCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <gt-delDig @delData="getDelData"></gt-delDig>
  </div>
</template>

<script>
import { getQuickCashList } from '../../api';

export default {
  data() {
    return {
      value: '', // 时间段
      inputVal: '', // 搜索值
      tableData: [], // 快捷收银记录
      pageNum: 1,
      pageCount: 1,
      total: '', // 收入总额
      totalOrderNum: '', // 总单数

      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteQuickOrder',
        text1: '',
        text2: '',
        status: false
      },
      loginType: ''
    };
  },
  watch: {
    'delForm.status': function (val) {
      if (val == true) {
        this.search();
      }
    }
  },
  activated() {
    this.loginType = window.sessionStorage.loginType;
    this.getListData();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTime(time) {
      this.value = time;
      this.chooseTime(time);
    },
    // 选择时间段
    chooseTime() {
      this.pageNum = 1;
      this.getListData();
    },
    // 搜索
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 删除订单
    delOrder(id) {
      // console.log(id)
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = 'deleteQuickOrder';
      this.delForm.text1 = '确认要删除这条订单吗？';
      this.delForm.text2 = '删除后订单数据将无法恢复';
      this.delForm.status = false;
    },
    // 调用公共组件--赋值
    getDelData(list) {
      this.delForm = list;
    },
    // 导出列表
    exportList() {
      const vm = this;
      if (vm.value) {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportQuickCashList?startDate=${
          vm.value[0]
        }&endDate=${
          vm.value[1]
        }&keyWord=${
          vm.inputVal}`;
      } else {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportQuickCashList?keyWord=${
          vm.inputVal}`;
      }
    },
    // 快捷收银记录
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getQuickCashList(data).then((res) => {
        vm.tableData = res.data.page.records;
        vm.totalOrderNum = res.data.page.total;
        vm.pageCount = res.data.page.total;
        vm.total = res.data.sumTotal;
      });
    }
  }
};
</script>
